<template>
  <div>
    <div class="modal-boddy">
      <div class="modal-text mr-2 ml-0 mt-2">
        <div v-if="termos.length > 0" class="area-termos pl-4 pt-4" style="height: 300px; overflow-y:scroll !important;">
            <span class="termo-item" v-for="termo in termos" :key="termo.id">
              <v-checkbox class="check-termo mr-4" v-model="termo.marcado">
                <template v-slot:label>
                  <span :class="{
                    'termo-obrigatorio-nao-aceito': validacaoTentada && termo.impeditivo && !termo.marcado
                  }">
                    <span v-if="termo.impeditivo" class="asterisco-impeditivo-sempre">*</span>{{ termo.descricao }}
                  </span>
                </template>
              </v-checkbox>
            </span>
            <br>
        </div>
        <div v-else class="area-termos pl-4 pt-5" style="text-align: center; height: 200px">
          <h2 class="mt-5" style="font-weight: bolder">Nenhum termo disponível no momento, você pode prosseguir.</h2>
        </div>
        <div class="aviso-termos-impeditivos">
          Os termos marcados com "*" são obrigatórios. Caso não sejam aceitos, o sistema impedirá o envio da proposta.
        </div>
      </div>
    </div>

    <div class="modal-actions__steps">
      <v-btn color="primary" outline @click="$emit('voltar')" class="btn-voltar">Voltar</v-btn>
      <span>Passo {{passoAtual}}/{{quantidadePassos}}</span>
      <v-tooltip v-if="!ehPerfilComprasBr" top :disabled="visualizouTodos && (!validacaoTentada || termosObrigatoriosAceitos)">
        <v-btn slot="activator" color="primary" @click="tentarFinalizar()" :disabled="!visualizouTodos || (validacaoTentada && !termosObrigatoriosAceitos)" class="btn-finalizar">{{ passoAtual === quantidadePassos ? 'Finalizar' : 'Avançar'}}</v-btn>
        É necessário visualizar todos os termos e aceitar os termos obrigatórios antes de finalizar.
      </v-tooltip>
      <v-tooltip v-else top :disabled="!validacaoTentada || termosObrigatoriosAceitos">
        <v-btn slot="activator" color="primary" @click="tentarFinalizar()" :disabled="validacaoTentada && !termosObrigatoriosAceitos" class="btn-finalizar">{{ passoAtual === quantidadePassos ? 'Finalizar' : 'Avançar'}}</v-btn>
        É necessário aceitar os termos obrigatórios para avançar.
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: 'LicitacaoFornecedorTermosPersonalizados',
  props: {
    value: {
      required: true
    },
    termos:{
      type: Array
    },
    passoAtual:{
      type: Number
    },
    quantidadePassos:{
      type: Number
    }
  },
  data() {
    return {
      visualizouTodos: false,
      todosMarcados: false,
      validacaoTentada: false
    }
  },
  computed: {
      ...mapState(['parametros']),
      ehPerfilComprasBr(){
          return this.parametros.propriedadesLicitacao.ehPerfilComprasBR
      },
      termosObrigatoriosAceitos(){
        const termosObrigatorios = this.termos.filter(termo => termo.impeditivo);
        return termosObrigatorios.every(termo => termo.marcado);
      }
  },
  mounted() {
    this.inicializarCondicionais()
  },
  methods: {
    inicializarCondicionais(){
      if(this.termos.length > 0){
        this.criarObserverScroll()
        this.atribuirTodosMarcados(this.termos)
      }else{
        this.visualizouTodos = true
        this.todosMarcados = true
      }
    },
    tentarFinalizar(){
      this.validacaoTentada = true;

      if (!this.termosObrigatoriosAceitos) {
        return;
      }

      this.finalizar();
    },
    finalizar(){
      const marcados = this.termos.filter(t => t.marcado).map(t => t.id)
      this.value.termosAceitos = this.value.termosAceitos.filter(termo => !this.termos.includes(termo))
      this.value.termosAceitos.push(...marcados)
      this.$emit('proximo')
    },
    criarObserverScroll(){
      const targets = document.querySelectorAll('.termo-item');
      const target = targets[targets.length-1]
      let options = {
        root: null,
        rootMargin: "0px",
        threshold: [1]
      }

      let callback = (entries) => {
        entries.forEach((entry) => {
          if(entry.intersectionRatio >= 1){
            this.visualizouTodos = true
          }
        })
      }
      let observer = new IntersectionObserver(callback, options);
      observer.observe(target);
    },
    marcarDesmarcarTodos(valor){
      if(valor){
        this.termos.forEach(termo => termo.marcado = true)
      }else{
        this.termos.forEach(termo => termo.marcado = false)
      }
    },
    atribuirTodosMarcados(termos){
      if(termos.every(item => item.marcado === true)){
        this.todosMarcados = true
      }else {
        this.todosMarcados = false
      }
    }
  },
  watch:{
    termos:{
      handler(novoValor){
        this.atribuirTodosMarcados(novoValor)
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

.area-termos::-webkit-scrollbar {
  width: 12px;
  border-radius: 15px;
  background-color: #e5e5e5;
}

.area-termos::-webkit-scrollbar-thumb {
  border-radius: 15px;
  background-color: #a2a2a2;
}

.asterisco-impeditivo-sempre {
  color: red;
  margin-right: 3px;
  font-weight: bold;
}

.asterisco-impeditivo-nao-aceito {
  color: red;
  margin-right: 3px;
  font-weight: bold;
}

.termo-obrigatorio-nao-aceito {
  color: red;
}

.aviso-termos-impeditivos {
  color: black;
  margin-top: 15px;
  text-align: center;
  font-size: 14px;
}
</style>
